'use strict';

var _ = require('lodash');
var Backbone = require('backbone');
var $ = require('jquery');

var Cms = require('./models/cms');
var Geo = require('tscom-geo');
var Connect = require('tscom-connect');
var Facebook = require('./models/facebook');
var Auth = require('./models/auth');
var Router = require('./routes/router');
var Countdown = require('./models/countdown');
var VoteOption = require('./collections/vote-option');
var PubSub = require('tscom-pubsub');
var cookie = require('./util/cookie');
var constants = require('./constants');

const AUTH_METHOD_EMAIL = constants.connect.AUTH_METHOD_EMAIL;
const AUTH_METHOD_FB = constants.connect.AUTH_METHOD_FB;

function getQueryParamByName(name, url) {
    var regexS = '[\\?&]' + name + '=([^&#]*)';
    var regex = new RegExp(regexS);
    var results = regex.exec(url || window.location.toString());
    if (results === null) return '';
    else return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * Returns true if app is iframed and parent site is opened in mobile FB app
 * @return {[type]} [description]
 */
function detectAppLocation() {
    return top !== self && /FBAV/.test(navigator.userAgent) ? true : false;
}

module.exports = function init(opts) {
  
    var options = opts || {};
    options.container = options.container || $(document.body);
    options.widget_id = options.widget_id || '714000e0c3842403';

    options.endpoints = _.extend({
        cms: 'https://widgetstate.votenow.tv/v1/state/',
        connect: 'https://voteapi.votenow.tv/s2/vote'
    },$.type(options.endpoints) === 'object' ? options.endpoints : {});

    return new Controller(options);

};

function Controller(options) {
    this.Models = {};
    this.Collections = {};
    this.Views = {};
    this.Routers = {};

    this.options = options;

    //Detect the current environment.
    var env = _.getQueryParamByName('env');
    this.env = env;

    this.insideMobileApp = detectAppLocation();

    //Load config.php
    this.loadEnvironmentConfig()
        .then(this.updateEndpoints.bind(this)) // Update endpoints
        .then(this.loadDashboardWidget.bind(this)) // Set up CMS then fetch
        // Set up the models, router, etc.
        .then(this.setUpGeo.bind(this))
        .then(this.setUpCollection.bind(this))
        .then(this.setUpFacebook.bind(this))
        .then(this.setUpCountdown.bind(this))
        .then(this.setUpAuth.bind(this))
        .then(this.setUpConnect.bind(this))
        .then(this.getSubmittedVotes.bind(this))
        .then(this.setUpPym.bind(this))
        .then(this.setUpRouter.bind(this, options))
        .then(this.setUpListeners.bind(this))
        .then(this.startApp.bind(this))
        .fail(function(error) {
            console.warn('error setting up:', error);
        });
}

_.extend(
    Controller.prototype,
    {
        loadEnvironmentConfig: function() {
            var qsp = this.env? '?env=' + this.env : '';

            return $.ajax('/config/endpoints.php' + qsp);
        },

        updateEndpoints: function(response) {
            var options = this.options;
            options.endpoints = _.extend(options.endpoints, response);
            return options;
        },

        loadDashboardWidget: function() {
            var def = $.Deferred();
            var options = this.options;

            this.Models.Cms = new Cms(
                {
                    wid: options.widget_id,
                    apiUrl: options.endpoints.cms,
                    updateFrequency: 10
                },
                {
                    poll: true,
                    ignoreQSP: false
                }
            );

            var defCms = $.Deferred();
            $.when(defCms).always(function() {
                def.resolve();
            });

            return this.Models.Cms.fetch();
        },

        setUpGeo: function() {
            this.Models.Geo = new Geo({
                countries: this.Models.Cms.get('settings').countries
            });
            return this.Models.Geo.fetch({
                url: '/api/getregion.json'
            });
        },

        setUpCollection: function() {
            var sorting_key_cms = this.Models.Cms.get('text').views_nominee_grid.sorting_key;

            var show_eliminated = _.checkIfTrue(this.Models.Cms.get('text').views_nominee_grid.show_eliminated);
            var randomize = _.checkIfTrue(this.Models.Cms.get('text').views_nominee_grid.randomize_order);
            var sorting_key = sorting_key_cms !== '' ? sorting_key_cms : 'firstname';

            var data = this.Models.Cms.get('data');

            if(!show_eliminated) {
                this.Collections.VoteOption = new VoteOption(
                    _.where(data, {
                        eliminated: '0'
                    }),
                    {
                        randomize: randomize,
                        sorting_key: sorting_key
                    },
                    {
                        enable_eliminated: show_eliminated
                    }
                );
            } else {
                this.Collections.VoteOption = new VoteOption(
                    data,
                    {
                        randomize: randomize,
                        sorting_key: sorting_key
                    },
                    {
                        enable_eliminated: show_eliminated
                    }
                );
            }
        },

        setUpFacebook: function() {
            var isReauthEnabled = this.Models.Cms.get('text')['view_reauth']['enable_reauth'];
            var isFacebookLoginEnabled = this.Models.Cms.get('text')['views_login']['facebook_login']['enable'];

            this.Models.Facebook = new Facebook({
                appId: this.Models.Cms.get('social').fb.id,
                insideMobileApp: this.insideMobileApp,
                reauthEnabled: _.checkIfTrue(isReauthEnabled),
                isEnabled: _.checkIfTrue(isFacebookLoginEnabled),
            },{});
        },

        setUpCountdown: function() {
            this.Models.Countdown = new Countdown(
                {
                    //future_time: controller.Models.Cms.getCountdownTime(controller.Models.Cms.get('startTime')),
                    //countdown_status: controller.Models.Cms.get('countdownStatus'),
                    name: 'start timer'
                },
                {
                    cms: this.Models.Cms
                }
            );
        },

        setUpAuth: function() {
            this.Models.Auth = new Auth({},{
                facebook: this.Models.Facebook
            });
            this.listenTo(this.Models.Auth, 'change:isAuthorized', this.getSubmittedVotes.bind(this));
        },

        setUpConnect: function() {
            var settings = this.Models.Cms.get('settings');
            var options = this.options;

            this.Models.Connect = new Connect(
                {
                    apiKey: settings.apiKey
                },
                {
                    apiUrl: options.endpoints.connect,
                    apiSecret: settings.secretKey,
                    version_id: settings.version_id
                }
            );
            this.Models.Connect.apiUrl = options.endpoints.connect;
            this.Models.Connect.versionCheck = 'Xxfo9AKaD4KdaPh39';    
        },

        getSubmittedVotes: function() {

            if(this.Models.Connect && this.Models.Auth.get('isAuthorized')) {

                var attrs = {
                    action_type: constants.connect.ACTION_TYPE_GET,
                    method: this.Models.Auth.get('authType'),
                    timestamp: this.Models.Cms.get('ts'),
                    user_id: this.Models.Auth.get('userID')
                };

                this.Models.Connect.save(attrs).then(function(response){
                    var totalSubmittedVotes = response.total_votes.length > 0 ? parseInt(response.total_votes,10) : 0;
                    this.Models.Auth.setSubmittedVotes(totalSubmittedVotes);
                    
                    if(this._pendingVotes) {
                        this.castVote(this._pendingVotes);
                        this._pendingVotes = null;
                    }

                }.bind(this));
            }
        },

        setUpPym: function() {
            // initialize pym.js if app is iframed
            if (top !== self) {
                //moved to router
                // this.Models.pymChild = new pymJS.Child( { polling: 500 } );

                if (this.insideMobileApp) {
                    // var url = this.Models.pymChild.parentUrl;
                    var url = _.getQueryParamByName('parentUrl');
                    var accessToken =
                        getQueryParamByName('#access_token', url) ||
                        getQueryParamByName('access_token', url) ||
                        cookie.readCookie('manualLogin');
                    var accessTokenExpiration = parseInt(
                        getQueryParamByName('expires_in') || 0,
                        10
                    );

                    if (accessToken) {
                        this.manualOAuth(accessToken, accessTokenExpiration);
                    }
                }
            }
        },

        setUpRouter: function(options) {
            this.Routers.Router = new Router({
                controller: this,
                cms: this.Models.Cms,
                facebook: this.Models.Facebook,
                connect: this.Models.Connect,
                auth: this.Models.Auth,
                voteOption: this.Collections.VoteOption,
                container: options.container,
                uniqueId: options.uniqueId
            });
        },

        setUpListeners: function() {
            // add to setUpListeners
            this.listenTo(this.Models.Auth, 'clearUser', this.clearUser.bind(this));
            this.listenTo(this.Models.Connect, 'sync', this.handleVoteApiResponse.bind(this));

            this.listenTo(PubSub, 'castVote', this.castVote.bind(this));
            this.listenTo(PubSub, 'clearUser', this.clearUser.bind(this));
            this.listenTo(PubSub, 'trackGoogle', this.trackGoogle.bind(this));
            this.listenTo(PubSub, 'clearPendingVotes', this.clearPendingVotes.bind(this));

            this.listenTo(this.Models.Cms, 'change:sid', function(){
                this.setUpCollection();
                if (this.isWindowOpen()) {
                    // Update the router with the new CMS data
                    this.Routers.Router.voteOption = this.Collections.VoteOption;
                    this.Routers.Router.home();
                } else {
                    this.Routers.Router.window();
                }
            }.bind(this));
        },

        clearPendingVotes: function() {
            this._pendingVotes = null;
        },

        startApp: function() {
            var isInRegion = this.Models.Geo.get('inRegion');
            var isWindowOpen = this.isWindowOpen();

            //if the user is not in a valid region, show the geo view
            if (!isInRegion) {
                this.Routers.Router.geo();
            } else {
                //if the user is in a valid region and the window is open
                if (isWindowOpen) {
                    this.Routers.Router.home();
                    //if the user in in a valid region but the window is closed
                } else {
                    this.Routers.Router.window();
                }
            }
        },

        isWindowOpen: function() {

            var windowStatus = parseInt(this.Models.Cms.get('settings')['window_status'],10);

            if (windowStatus === 1) {
                return true;
            }

            return false;
        },

        trackGoogle: function(data) {
            window.dataLayer.push(data);
        },

        clearUser: function() {
            console.log('CLEAR USER');
            if (!_.isUndefined(this.Models.Vote)) {
                this.Models.Vote.clear();
                this.Models.Vote = null;
                delete this.Models.Vote;
            }

            this.Models.Auth.set(this.Models.Auth.defaults);
            this.Models.Auth.setSubmittedVotes(0);
            this.Models.Facebook.clearUser();
            this.Collections.VoteOption.clearVoteCount();
            this.Models.Connect.clear({ silent: true }).set(this.Models.Connect.defaults);
            this.Models.Connect.set('apiKey',this.Models.Cms.get('settings').apiKey);

            // clear out stored opt-ins, if any

            for (var x in localStorage) {
                if (localStorage.hasOwnProperty(x)) {
                    if (x.indexOf('optin-') !== -1) {
                        localStorage.removeItem(x);
                    }
                }
            }

            // close any open models
            this.Routers.Router.closeCurrentModal();
        },

        manualOAuth: function(accessToken, accessTokenExpiration) {
            cookie.createCookie(
                'manualLogin',
                accessToken,
                accessTokenExpiration
            );

            console.log('manualOAuth', accessToken);
            var deferred = $.Deferred();

            this.Models.Facebook.set({ accessToken: accessToken });
            this.Models.Facebook.setUserDataWithToken(deferred);

            deferred.then(
                function(user) {
                    this.Models.Auth.set({
                        isAuthorized: true,
                        authType: 'facebook',
                        userName: user.name,
                        userID: user.email
                    });
                }.bind(this)
            );
        },

        stopPolling: function() {
            return;
        },

        patchCmsData: function(newData) {
            var cms = this.Models.Cms;
            // why not _.extend? we want a deep extend below, and might
            // as well use the same method in both cases
            var data = $.extend({}, cms.attributes);

            data = $.extend(true, data, newData);

            cms.set(data);
            console.info('votewidget.js data: ', data);
            console.info('votewidget.js cms: ', cms);

            cms.trigger('change:text');
            this.Routers.Router.home();
        },

        randomizeData: function() {
            var cms = this.Models.Cms;

            // why not _.extend? we want a deep extend below, and might
            // as well use the same method in both cases
            var data = $.extend({}, cms.attributes);

            var colorValue = parseInt(Math.random() * 0xffffff, 10).toString(16);
            var newData = {
                ts: Math.random(),
                text: {
                    design: {
                        css: {
                            vote_button: {
                                color: '#' + colorValue
                            }
                        }
                    }
                }
            };

            data = $.extend(true, data, newData, {
                foobar: Math.random()
            });

            this.Models.Cms.set(data);

            this.Routers.Router.home();
        },

        /* We need a way for the user to cleanly remove our widget. */
        remove: function() {
            console.log(this);
            if (this.Routers.Router) {
                this.Routers.Router.destroy();
                this.Routers.Router.controller = null;

                _.each(this.Models, function(model, key) {
                    console.log('removing ', key);
                    if (model.off) {
                        model.off();
                        model.stopListening();
                        model.controller = null;
                    }
                    delete this.Models[key];
                });

                _.each(this.Collections, function(collection, key) {
                    console.log('removing ', key);
                    if (collection) {
                        collection.off();
                        collection.stopListening();
                        collection.reset();
                        collection.controller = null;
                    }
                    delete this.Collections[key];
                });

                this.Collections = {};

                _.each(this.Views, function(view, key) {
                    console.log('removing ', key);
                    if (view) {
                        view.off();
                        view.stopListening();
                        view.remove();
                        view.controller = null;
                    }
                    delete this.Views[key];
                });

                this.Models = {};
                this.Views = {};
                this.Controllers = {};
                this.Routers = {};
            } else {
                console.warn(
                    'Vote Widget:  Cannot be removed before initialization.'
                );
            }
        },

        //util functions for connect
        getUserData: function() {
            var data = {};
            var fbModel = this.Models.Facebook;
            var authModel = this.Models.Auth;
            var authType = authModel.get('authType');

            if (authType === AUTH_METHOD_EMAIL) {

                _.extend(data, {
                    user_id: authModel.get('userID'),
                    method: AUTH_METHOD_EMAIL
                });

            } else if (authType === AUTH_METHOD_FB) {

                _.extend(data, {
                    user_id: fbModel.get('user').identifier,
                    fb_first_name: fbModel.get('user').first_name,
                    fb_last_name: fbModel.get('user').last_name,
                    fb_email: fbModel.get('user').email,
                    method: AUTH_METHOD_FB
                });
            }

            return data;
        },
        /**
         * [ getVoteData ]
         */
        getVoteData: function(voteCount) {
            var data = {};
            var selected = this.Collections.VoteOption.getSelected();

            if(_.isObject(selected)) {

                data.v = selected.get('id');
                data.total = voteCount;

                return data;
            } else {
                return null;
            }
        },

        /**
         * @todo: ask tech ops if they can expose an endpoint to access optin or other user data
         * instead of storing data on the client side
         *
         */
        getOptinData: function() {
            var optins = {};
            for (var x in localStorage) {
                if (localStorage.hasOwnProperty(x)) {
                    if (x.indexOf('optin-') !== -1) {

                        optins[this.normalizeParamName(x)] = localStorage[x] === 'true' ? 1 : 0;
                    }
                }
            }
            return optins;
        },
        
        normalizeParamName: function(x){
            return x.replace('-', '_');
        },

        castVote: function(voteCount) {

            if(!this.Models.Auth.get('isAuthorized')) {
                this._pendingVotes = voteCount;
                return this.Routers.Router.auth();
            }

            var voteData = this.getVoteData(voteCount);
            if(!voteData) return;

            var attrs = {
                action_type: constants.connect.ACTION_TYPE_VOTE,
                timestamp: this.Models.Cms.get('ts'),
                country: this.Models.Geo.get('country'),
                state: this.Models.Geo.get('geoheaders').region
            };

            _.extend(
                attrs,
                this.getOptinData(),
                this.getUserData(),
                voteData
            );

            this.Models.Connect.save(attrs);
            this.Routers.Router.loading();
        },

        handleVoteApiResponse: function(model) {
            console.log('requestActionVoteSuccess:\t', model);

            if(!model.get('action_type') || model.get('action_type') === constants.connect.ACTION_TYPE_GET) {
                return;
            }

            var totalVotes = model.get('response').total_votes.length > 0 ? parseInt(model.get('response').total_votes,10) : 0;
            this.Models.Auth.setSubmittedVotes(totalVotes);

            switch (model.get('response').response_code) {
            case '20':
                this.Routers.Router.thanks();
                break;
            case '21':
                this.Routers.Router.error('overlimit');
                break;
            case '16':
                this.Routers.Router.error();
                break;
            case '40':
                this.Routers.Router.error('window');
                break;
            case '22':
                this.Routers.Router.error('ge0');
                break;
            default:
                this.Routers.Router.error();
            }
        }
    },
    Backbone.Events
);



// WEBPACK FOOTER //
// ./app/scripts/VoteWidget.js